//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Charlson_Index',
  data() {
    return {
      form: {
        age: '',
        myocardialInfarct:'0',
        heart_ailure:'0',
        vascular_disease:'0',
        cerebrovascular_disease:'0',
        dementia:'0',
        lung_disease:'0',
        tissue_disease:'0',
        ulcer:'0',
        liver_disease:'',
        diabetes:'',
        hemiplegia:'0',
        kidney_disease:'0',
        solid_tumor:'0',
        leukemia:'0',
        lymphoma:'0',
        AIDS:"0",
        tumor:''
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "无" },
        { value: "1", name: "轻度肝病" },
        { value: "3", name: "中度或重度肾脏疾病" },
      ],
      dataList1: [
        { value: "0", name: "无" },
        { value: "1", name: "糖尿病" },
        { value: "2", name: "糖尿病伴终末器官损伤" },
      ],
      dataList2: [
        { value: "0", name: "无" },
        { value: "2", name: "非转移性实体瘤" },
        { value: "6", name: "转移性肿瘤" },
      ],
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result
        self.hasScore = true;
        if(form.age >=50 && form.age <=59) {
          form.age = 1
        }else if(form.age >=60 && form.age <=69) {
          form.age = 2
        }else if(form.age >=70 && form.age <=79) {
          form.age = 3
        }else if(form.age >=80 && form.age <=89) {
          form.age = 4
        }else if(form.age >=90 && form.age <=99) {
          form.age = 5
        }else if(form.age >=100 && form.age <=109) {
          form.age = 6
        }else if(form.age >=110 && form.age <=119) {
          form.age = 7
        } else {
          form.age = 0
        }
        console.log(form);
        result = form.age + (form.myocardialInfarct ? 1 :0) +(form.heart_ailure ? 1 : 0) +
        (form.vascular_disease ? 1:0) +
        (form.cerebrovascular_disease ? 1:0) +
        (form.dementia ? 1: 0) +
        (form.lung_disease ? 1 : 0) +
        (form.tissue_disease? 1 :0) +
        (form.ulcer ? 1 :0) +
        (form.liver_disease ? 1 : 0) +
        (form.diabetes ? 1 :0) +
        (form.hemiplegia ? 2 :0) +
        (form.organ_damage ? 2:0) +
        (form.kidney_disease ? 2:0) +
        (form.solid_tumor ? 2 :0) +
        (form.leukemia ? 2:0) +
        (form.lymphoma ? 2:0) +
        (form.severe_liver_disease ? 3 :0 )+
        (form.AIDS ? 6 :0) +
        (form.metastatic_tumor ? 6 :0)
        console.log(result);
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Charlson_Index.vue